export const LARGE = 'large';
export const SMALL = 'small';
export const BANNER = 'Banner';
export const BANNER_INFO = 'BannerInfo';
